// removed by extract-text-webpack-plugin
module.exports = {"base":"VehiclesCarousel_base--2ETHc","item":"VehiclesCarousel_item--2jI-o"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/VehiclesCarousel/VehiclesCarousel.scss
// module id = 465
// module chunks = 11 12